// extracted by mini-css-extract-plugin
export default {"row":"billing_row__2PdNf","wrapper":"billing_wrapper__cf3eX","loader":"billing_loader__g0S8l","col":"billing_col__qNvkZ","card":"billing_card__sAl-+"};